import { render, staticRenderFns } from "./FlashCardsForm.vue?vue&type=template&id=23baa3fb&scoped=true&lang=pug&"
import script from "./FlashCardsForm.vue?vue&type=script&lang=js&"
export * from "./FlashCardsForm.vue?vue&type=script&lang=js&"
import style0 from "./FlashCardsForm.vue?vue&type=style&index=0&id=23baa3fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23baa3fb",
  null
  
)

export default component.exports